import { Avatar, CssBaseline, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Footer } from "../../components/footer";

export const SecurityLayout = ({ children }) => {
  return (
    <Box>
      <CssBaseline />
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "#212121" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography style={{ marginTop: "10px" }} component="h1" variant="h5">
            Login
          </Typography>

          <Box>{children}</Box>
        </Box>
        <Footer />
      </Container>
    </Box>
  );
};
